module.exports = __webpack_public_path__ + "img/vaxrx-presentation.03817139.png";